module.exports = __webpack_public_path__ + "static/kakuro1-fdc9c77de063e4c13b17ab790a107bae.png";